<!-- Do not change this file. -->

<template>
  <div class="navbar navbar-dark bg-dark">
    <div class="container-fluid">
      <div class="navbar-brand d-flex" role="banner">
        <img
          src="@/assets/logo-dark.svg"
          alt="Oregon State University Logo"
          height="30"
          class="d-inline-flex align-top me-3 pe-3 border-end"
        />
        <div class="title me-3 fw-bold">{{ course }}</div>
        <!-- Displayed for medium and large screens -->
        <div class="subtitle d-none d-sm-block">{{ title }}</div>
        <!-- Displayed only for small screens -->
        <div class="subtitle d-sm-none">{{ shortTitle }}</div>
      </div>
      <div>
        <TheSupportButton />
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import config from "@/data/config";
import TheSupportButton from "@/components/core/TheSupportButton.vue";

export default {
  name: "TheHeader",
  components: {
    TheSupportButton
  },
  data() {
    return {
      course: config.meta.course,
      title: config.meta.title,
      shortTitle: config.meta.shortTitle
    };
  }
};
</script>
